import { RouteObject } from "react-router-dom"
import { SubPageForYou } from "./subPages/SubPageForyou"
import { SubPageGameCategory } from "./subPages/SubPageGameCategory"
import { SubPageGameSection } from "./subPages/SubPageGameSection"

export const homeSubPageRoutes: RouteObject[] = [
    {
        path: "",
        element: <SubPageForYou />,
    },
]

export const gameCategorySubPageRoutes: RouteObject[] = [
    {
        path: "",
        element: <SubPageGameCategory />,
    },
]

export const gameSectionsPageRoutes: RouteObject[] = [
    {
        path: "",
        element: <SubPageGameSection />,
    },
]
